import React from 'react';
import { Controller } from 'react-hook-form';
import { DatePicker, Form } from 'antd';
import dayjs from 'dayjs';

const SelectTime = ({
  errors = {},
  control,
  required = false,
  defaultValue,
}) => {
  return (
    <Form.Item
      label="Thời gian"
      validateStatus={errors.time ? 'error' : ''}
      help={errors.time?.message}
      required={required}
    >
      <Controller
        control={control}
        name="time"
        rules={
          required && {
            required: 'Hãy nhập thời gian!',
            validate: (value) =>
              value &&
              dayjs(value).isBetween(
                dayjs().subtract(7, 'day').startOf('day'),
                dayjs().endOf('day'),
                null,
                '[]',
              )
                ? true
                : 'Chỉ được chọn từ hôm nay đến 7 ngày trước!',
          }
        }
        render={({ field }) => {
          return (
            <DatePicker
              showTime={false}
              defaultValue={defaultValue}
              format="DD/MM/YYYY"
              {...field}
              onChange={(value) => {
                field.onChange(value);
              }}
              onOk={(value) => field.onChange(value)}
              rootClassName="w-full"
              disabledDate={(current) => {
                return current && current < dayjs().startOf('day');
              }}
              getPopupContainer={(triggerNode = {}) => {
                return triggerNode?.parentNode;
              }}
            />
          );
        }}
      />
    </Form.Item>
  );
};

export default SelectTime;
